import { render } from "./PaypalPayment.vue?vue&type=template&id=0f786952"
import script from "./PaypalPayment.vue?vue&type=script&lang=js"
export * from "./PaypalPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__